import { getBezierPath, oppositePosition } from '../../core';
import { selectConnection, selectNodesConnectable, useMindmapStore } from '../../store';

/** The bezier line shown while dragging a new connection; hidden when `nodesConnectable` is false (v11). */
export const ConnectionLine = () => {
  const connection = useMindmapStore(selectConnection);
  const nodesConnectable = useMindmapStore(selectNodesConnectable);
  if (!connection || !nodesConnectable) return null;
  const { fromPoint, fromPosition, toPoint } = connection;
  const [path] = getBezierPath({
    sourceX: fromPoint.x,
    sourceY: fromPoint.y,
    sourcePosition: fromPosition,
    targetX: toPoint.x,
    targetY: toPoint.y,
    targetPosition: oppositePosition(fromPosition),
  });
  return (
    <svg className="cm-connection-line">
      <g className="cm-connection">
        <path d={path} fill="none" className="cm-connection-path" />
      </g>
    </svg>
  );
};
